const PHONE_MODES = new Set(['auto', 'collaboration'])

export function canChangePhoneMode(status = {}) {
  return status.activeCall !== true && status.agentState !== 'After_Call_Work'
}

export function createInitialPhoneState() {
  return {
    instanceId: 'llmbot-next-phone',
    opened: false,
    mode: undefined,
    status: { state: 'loading', activeCall: false, agentState: '' },
  }
}

export function reducePhoneState(state, action) {
  if (action?.type === 'OPEN' && PHONE_MODES.has(action.mode)) {
    if (state.mode && state.mode !== action.mode && !canChangePhoneMode(state.status)) {
      return state
    }
    if (state.opened && state.mode === action.mode) return state
    return { ...state, opened: true, mode: action.mode }
  }
  if (action?.type === 'STATUS') {
    return { ...state, status: action.status }
  }
  if (action?.type === 'CLOSE') return createInitialPhoneState()
  return state
}
